import axios, { AxiosResponse } from 'axios'
import { getUserToken } from '../utility/localStorageFunctions'
import { getDefaultQueryString } from '../utility/queryFunctions'
import {
  ServicedArea,
  ServicedAreas,
  SupplierOperation,
  SupplierOperationsAPIResponse,
} from './supplierOperationsAPI.types'

const BASE_URL = `${process.env.REACT_APP_BASE_API_URL}/supplierOperations-api/supplierOperations`

const getSupplierOperations = async (): Promise<
  AxiosResponse<SupplierOperationsAPIResponse>
> => {
  const token = await getUserToken('supplierOperations')
  const response = await axios({
    method: 'get',
    url: BASE_URL,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}

//TODO: fix operations screen so percentage and price are numbers via YUP validation
const mapSupplierOperation = (supplierOperation: SupplierOperation) => {
  const mapped = {
    ...supplierOperation,
    ...(supplierOperation?.adminFeePolicy?.chargeTypeName && {
      adminFeePolicy: {
        chargeTypeName: supplierOperation.adminFeePolicy.chargeTypeName,
        ...(supplierOperation.adminFeePolicy.chargeTypeName === 'Fixed' && {
          price:
            supplierOperation &&
            supplierOperation.adminFeePolicy &&
            supplierOperation.adminFeePolicy.price &&
            parseFloat(supplierOperation.adminFeePolicy.price + ''),
        }),
        ...(supplierOperation.adminFeePolicy.chargeTypeName ===
          'Percentage' && {
          percentage:
            supplierOperation &&
            supplierOperation.adminFeePolicy &&
            supplierOperation.adminFeePolicy.percentage &&
            parseFloat(supplierOperation.adminFeePolicy.percentage + ''),
        }),
      },
    }),
    ...(supplierOperation.serviceChargeValue && {
      serviceChargeValue: parseFloat(supplierOperation.serviceChargeValue + ''),
    }),
  }
  if (mapped.adminFeePolicy?.chargeTypeName === undefined) {
    delete mapped.adminFeePolicy
  }
  return mapped
}

const createSupplierOperations = async (
  supplierOperation: SupplierOperation,
) => {
  const mapped = mapSupplierOperation(supplierOperation)
  const token = await getUserToken('supplierOperations')
  const response = await axios({
    method: 'post',
    url: BASE_URL,
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      data: mapped,
    },
  })
  return response
}

const updateSupplierOperations = async (
  supplierOperation: SupplierOperation,
) => {
  const mapped = mapSupplierOperation(supplierOperation)
  console.log(`mapped `, JSON.stringify(supplierOperation))
  const token = await getUserToken('supplierOperations')
  const response = await axios({
    method: 'patch',
    url: BASE_URL?.concat(`/${supplierOperation.id}`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      data: mapped,
    },
  })
  return response
}

const getSupplierOperationsBySupplierId = async (
  supplierId: number,
): Promise<AxiosResponse<{ value: Array<SupplierOperation> }>> => {
  const token = await getUserToken('supplierOperations')
  const response = await axios({
    method: 'get',
    url: BASE_URL?.concat(
      getDefaultQueryString('supplierId', supplierId.toString()),
    ),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}
const getSupplierOperationsBySupplierOperationsId = async (
  supplierOperationsId: string,
): Promise<AxiosResponse<SupplierOperation>> => {
  const token = await getUserToken('supplierOperations')
  const response = await axios({
    method: 'get',
    url: BASE_URL?.concat(`/${supplierOperationsId}`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}

const getServicedAreasBySupplierOperationsId = async (
  supplierOperationsId: number,
): Promise<AxiosResponse<ServicedAreas>> => {
  const token = await getUserToken('supplierOperations')
  const response = await axios({
    method: 'get',
    url: BASE_URL?.concat(`/${supplierOperationsId}`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  console.log(response.data.servicedAreas)
  return response.data.servicedAreas
}

const createServicedArea = async (
  supplierOperationsId: number,
  servicedArea: Array<ServicedArea>,
  operatingHours: any,
) => {
  const token = await getUserToken('supplierOperations')
  const response = await axios({
    method: 'PATCH',
    url: BASE_URL?.concat(`/${supplierOperationsId}`),
    headers: {
      Authorization: `Bearer ${token}`,
    },
    data: {
      data: { servicedAreas: servicedArea, operatingHours: operatingHours },
    },
  })
  return response
}

const deleteServicedArea = async (
  supplierOperationsId: number,
  servicedAreaId: number,
) => {
  const token = await getUserToken('supplierOperations')
  const response = await axios({
    method: 'delete',
    url: BASE_URL?.concat(
      `/${supplierOperationsId}/servicedAreas/${servicedAreaId}`,
    ),
    headers: {
      Authorization: `Bearer ${token}`,
    },
  })
  return response
}

export const supplierOperationsAPI = {
  getSupplierOperations,
  createSupplierOperations,
  updateSupplierOperations,
  getSupplierOperationsBySupplierId,
  getSupplierOperationsBySupplierOperationsId,
  getServicedAreasBySupplierOperationsId,
  createServicedArea,
  deleteServicedArea,
}
